import React, { useState } from "react";
import { toast } from "react-toastify";
import Select from 'react-select';

import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    CardTitle,
    Label,
    Button,
    Form,
    Input,
} from "reactstrap";
import { insertFestiveCategory } from "service/api";
import AdminGuard from "helpers/AuthType/AdminGuard";

const defaultvalue = {
    ptype: '',
    specification: '',
    price_from: '',
    price_to: '',
    img: [],
}

const FestiveForm = () => {
    const [rows1, setRows1] = useState([{ id: 1 }]);
    const [images, setImages] = useState([]);
    const [selectedPropertyType, setSelectedPropertyType] = useState(null);
    const handlePropertyTypeChange = (selectedOption) => {
        setSelectedPropertyType(selectedOption);
        // You can also store the selected value in your form state if needed
        console.log("Selected Property Type:", selectedOption);
    };


    // Add new row
    function handleAddRowNested() {
        setRows1([...rows1, { id: rows1.length + 1 }]);
    }

    // Remove row
    function handleRemoveRow(id) {
        if (rows1.length > 1) {
            setRows1(rows1.filter(row => row.id !== id));
        }
    }

    const propertyTypes = [
        { value: "Apartment", label: "Apartment" },
        { value: "Villa", label: "Villa" },
        { value: "Independent House", label: "Independent House" },
        { value: "Studio Apartment", label: "Studio Apartment" },
        { value: "Penthouse", label: "Penthouse" },
        { value: "Townhouse", label: "Townhouse" },
        { value: "Cottage", label: "Cottage" },
        { value: "Bungalow", label: "Bungalow" },
        { value: "Farmhouse", label: "Farmhouse" },
        { value: "Condominium", label: "Condominium" },
        { value: "Loft", label: "Loft" },
        { value: "Serviced Apartment", label: "Serviced Apartment" },
        { value: "Office Space", label: "Office Space" },
        { value: "Retail Space", label: "Retail Space" },
        { value: "Warehouse", label: "Warehouse" },
        { value: "Industrial Property", label: "Industrial Property" },
        { value: "Shop", label: "Shop" },
        { value: "Showroom", label: "Showroom" },
        { value: "Hotel", label: "Hotel" },
        { value: "Restaurant", label: "Restaurant" },
        { value: "Agricultural Land", label: "Agricultural Land" },
        { value: "Plot/Land", label: "Plot/Land" },
        { value: "Beach House", label: "Beach House" },
        { value: "Mountain Cabin", label: "Mountain Cabin" },
        { value: "Vacation Home", label: "Vacation Home" },
        { value: "Luxury Estate", label: "Luxury Estate" },
        { value: "Heritage Property", label: "Heritage Property" },
        { value: "Eco-Friendly Home", label: "Eco-Friendly Home" },
        { value: "Smart Home", label: "Smart Home" },
        { value: "Garage", label: "Garage" },
        { value: "Parking Space", label: "Parking Space" },
        { value: "Storage Unit", label: "Storage Unit" },
        { value: "Mixed-Use Property", label: "Mixed-Use Property" },
    ];

    const onFileChange = (e, index) => {
        const updatedImages = [...images];
        updatedImages[index] = e.target.files[0];
        setImages(updatedImages);
    };

    const addFestive_category = async (e) => {
        e.preventDefault();

        const area = document.getElementById("area").value;
        const specification = document.getElementById("specification").value;
        const price_from = document.getElementById("price_from").value;
        const price_to = document.getElementById("price_to").value;
        const ptype = selectedPropertyType ? selectedPropertyType.value : "";

        if (!ptype || !area || !specification || !price_from || !price_to || images.length === 0) {
            toast.error("Please fill all fields and upload at least one image.");
            return;
        }

        const formData = new FormData();
        formData.append("ptype", ptype);
        formData.append("area", area);
        formData.append("specification", specification);
        formData.append("price_from", price_from);
        formData.append("price_to", price_to);

        images.forEach((img) => {
            if (img) formData.append("images", img);
        });

        try {
            const res = await insertFestiveCategory(formData);
            if (res && res.success) {
                toast.success("Festive category added successfully!");
            } else {
                toast.error("Insertion failed.");
            }
        } catch (error) {
            toast.error("Something went wrong!");
            console.error("Insertion error:", error);
        }
    };


    return (
        <AdminGuard>
            <React.Fragment>
                <div className="page-content" style={{ color: "#fff", fontFamily: "'Roboto', sans-serif" }}>
                    <Container fluid={true} className="py-1">
                        <Row className="justify-content-center">
                            <Col xl={6} lg={6} md={12}>
                                <Card style={{ background: "rgba(255, 255, 255, 0.1)", border: "none", borderRadius: "15px" }}>
                                    <CardBody>
                                        <CardTitle className="mb-4 text-center" style={{ fontSize: "1.8rem", fontWeight: "600" }}>
                                            Add Festive-Categories
                                        </CardTitle>
                                        <Form onSubmit={addFestive_category} encType="multipart/form-data">
                                            <Row>
                                                <Col sm="4">
                                                    <div className="mb-3">
                                                        <Label htmlFor="propertytype">Property Type</Label>
                                                        <Select
                                                            id="ptype"
                                                            name="ptype"
                                                            options={propertyTypes}
                                                            value={selectedPropertyType}
                                                            onChange={(selectedOption) => {
                                                                handlePropertyTypeChange(selectedOption);
                                                                onValueChange({ target: { name: "ptype", value: selectedOption.value } });
                                                            }}
                                                            placeholder="Select Property Type"
                                                            isSearchable
                                                            styles={{
                                                                control: (base) => ({
                                                                    ...base,
                                                                    backgroundColor: "rgba(255, 255, 255, 0.2)",
                                                                    color: "#fff",
                                                                    border: "none",
                                                                }),
                                                                menu: (base) => ({
                                                                    ...base,
                                                                    backgroundColor: "#333",
                                                                    color: "#fff",
                                                                }),
                                                                option: (base, { isFocused }) => ({
                                                                    ...base,
                                                                    backgroundColor: isFocused ? "#555" : "#333",
                                                                    color: "#fff",
                                                                }),
                                                                singleValue: (base) => ({
                                                                    ...base,
                                                                    color: "#fff",
                                                                }),
                                                                input: (base) => ({
                                                                    ...base,
                                                                    color: "#fff",
                                                                }),
                                                            }}
                                                        />

                                                    </div>
                                                </Col>

                                                <Col md={6}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="title">Area</Label>
                                                        <Input
                                                            type="text"
                                                            className="form-control"
                                                            id="area"
                                                            name="area"
                                                            placeholder="Area"
                                                            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                        />
                                                    </div>
                                                </Col>

                                                <Col md={4}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="title">Specification</Label>
                                                        <Input
                                                            type="text"
                                                            className="form-control"
                                                            id="specification"
                                                            name="specification"
                                                            placeholder="Specification"
                                                            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={3}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="title">Price From</Label>
                                                        <Input
                                                            type="text"
                                                            className="form-control"
                                                            id="price_from"
                                                            name="price_from"
                                                            placeholder="price from"
                                                            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={3}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="title">Price To</Label>
                                                        <Input
                                                            type="text"
                                                            className="form-control"
                                                            id="price_to"
                                                            name="price_to"
                                                            placeholder="price to"
                                                            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                        />
                                                    </div>
                                                </Col>


                                                <div className="inner-repeater mb-4">
                                                    <table style={{ width: "100%" }}>
                                                        <tbody>
                                                            {rows1.map((formRow, index) => (
                                                                <tr key={index}>
                                                                    <td>
                                                                        <Row className="mb-2">
                                                                            <Col md="6">
                                                                                <Label>Upload Image</Label>
                                                                                <Input
                                                                                    type="file"
                                                                                    name={`img-${index}`}
                                                                                    onChange={(e) => onFileChange(e, index)}
                                                                                    className="inner form-control"
                                                                                    style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                                />
                                                                            </Col>
                                                                            <Col md="2 py-4">
                                                                                {index !== 0 && (
                                                                                    <Button
                                                                                        color="danger"
                                                                                        className="btn-block inner"
                                                                                        style={{ width: "100%" }}
                                                                                        onClick={() => handleRemoveRow(formRow.id)}
                                                                                    >
                                                                                        Delete
                                                                                    </Button>
                                                                                )}
                                                                            </Col>
                                                                        </Row>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                    <Button onClick={handleAddRowNested} color="success" className="mt-1">
                                                        Add More
                                                    </Button>
                                                </div>
                                            </Row>

                                            <div className="text-center">
                                                <button
                                                    type="submit"

                                                    style={{
                                                        width: "100%",
                                                        fontWeight: "600",
                                                        background: "linear-gradient(to right, #6a11cb, #2575fc)",
                                                        border: "none",
                                                        padding: "10px 20px",
                                                        borderRadius: "25px",
                                                    }}
                                                >
                                                    Save
                                                </button>
                                            </div>
                                        </Form>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        </AdminGuard>
    )
}

export default FestiveForm
